UC.partials.V6PAJ = UC.partials.V4PAJ.extend({
  live_chatStage: function(_eventParams) {
    this.activeSteps.push(new UC.partials.LiveChat({
      el: this.$el,
      nextButtonCallback: this.nextButtonClicked.bind(this)
    }));
  },
});

